export default __webpack_public_path__ + "static/2.2_EN-c1ca50d6dce540fbdb72d906047a8c1d.webp";